var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaCreateInstanceDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic instances",
    clipPath: "url(#clip0_0_31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic instances"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9028 7.43229H3.09722C2.00757 7.43229 1.125 6.54972 1.125 5.46007V3.48785C1.125 2.39819 2.00757 1.51562 3.09722 1.51562H16.9028C17.9924 1.51562 18.875 2.39819 18.875 3.48785V5.46007C18.875 6.54972 17.9924 7.43229 16.9028 7.43229Z",
    fill: "url(#paint0_linear_0_31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9028 13.3464H3.09722C2.00757 13.3464 1.125 12.4638 1.125 11.3741V9.40191C1.125 8.31226 2.00757 7.42969 3.09722 7.42969H16.9028C17.9924 7.42969 18.875 8.31226 18.875 9.40191V11.3741C18.875 12.4638 17.9924 13.3464 16.9028 13.3464Z",
    fill: "url(#paint1_linear_0_31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.9028 19.2682H3.09722C2.00757 19.2682 1.125 18.3857 1.125 17.296V15.3238C1.125 14.2341 2.00757 13.3516 3.09722 13.3516H16.9028C17.9924 13.3516 18.875 14.2341 18.875 15.3238V17.296C18.875 18.3857 17.9924 19.2682 16.9028 19.2682Z",
    fill: "url(#paint2_linear_0_31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9858 5.4566H5.06912C4.5238 5.4566 4.08301 5.01482 4.08301 4.47049C4.08301 3.92615 4.5238 3.48438 5.06912 3.48438H10.9858C11.5311 3.48438 11.9719 3.92615 11.9719 4.47049C11.9719 5.01482 11.5311 5.4566 10.9858 5.4566Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.9304 5.4566C15.4751 5.4566 15.9166 5.0151 15.9166 4.47049C15.9166 3.92587 15.4751 3.48438 14.9304 3.48438C14.3858 3.48438 13.9443 3.92587 13.9443 4.47049C13.9443 5.0151 14.3858 5.4566 14.9304 5.4566Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.9858 11.3785H5.06912C4.5238 11.3785 4.08301 10.9367 4.08301 10.3924C4.08301 9.84803 4.5238 9.40625 5.06912 9.40625H10.9858C11.5311 9.40625 11.9719 9.84803 11.9719 10.3924C11.9719 10.9367 11.5311 11.3785 10.9858 11.3785Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.9304 11.3785C15.4751 11.3785 15.9166 10.937 15.9166 10.3924C15.9166 9.84775 15.4751 9.40625 14.9304 9.40625C14.3858 9.40625 13.9443 9.84775 13.9443 10.3924C13.9443 10.937 14.3858 11.3785 14.9304 11.3785Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.9858 17.2925H5.06912C4.5238 17.2925 4.08301 16.8508 4.08301 16.3064C4.08301 15.7621 4.5238 15.3203 5.06912 15.3203H10.9858C11.5311 15.3203 11.9719 15.7621 11.9719 16.3064C11.9719 16.8508 11.5311 17.2925 10.9858 17.2925Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.9304 17.2925C15.4751 17.2925 15.9166 16.851 15.9166 16.3064C15.9166 15.7618 15.4751 15.3203 14.9304 15.3203C14.3858 15.3203 13.9443 15.7618 13.9443 16.3064C13.9443 16.851 14.3858 17.2925 14.9304 17.2925Z",
    fill: "#8BABF8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_31",
    x1: -8.57833,
    y1: 2.56167,
    x2: -3.05172,
    y2: 16.5316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_31",
    x1: -8.57833,
    y1: 8.47573,
    x2: -3.05172,
    y2: 22.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_31",
    x1: -8.57833,
    y1: 14.3976,
    x2: -3.05172,
    y2: 28.3676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FCFBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaCreateInstanceDark);
export default __webpack_public_path__ + "static/media/figma-create-instance-dark.074605ad08b586ae6e733f9df293a3c2.svg";
export { ForwardRef as ReactComponent };